import React from 'react';
import { useHistory } from 'react-router-dom';
import { canModifyContent } from '@/lib/account-roles';
import {
  useAllVendorsQuery,
  useVendorCategoriesQuery,
} from '@/queries/vendors';
import { useAuthStore } from '@/stores/auth-store';
import {
  HOME_TABS,
  useHomeDashboardStore,
} from '@/stores/home-dashboard-store';
import { FestivalHeader, Loading } from '../controls';
import { VendorTable } from './';

export function Vendors() {
  const history = useHistory();
  const currentUser = useAuthStore((s) => s.currentUser);
  const canModify = canModifyContent(currentUser);
  const setActiveTab = useHomeDashboardStore((s) => s.setActiveTab);
  const vendorsQ = useAllVendorsQuery();
  const categoriesQ = useVendorCategoriesQuery();

  const vendors = vendorsQ.data ?? [];
  const loading =
    vendorsQ.isPending ||
    vendorsQ.isFetching ||
    categoriesQ.isPending ||
    categoriesQ.isFetching;

  return (
    <>
      <FestivalHeader
        variant="bethere"
        title="My Vendors"
        subtitle="These are vendors you've used before. You can reuse or select them from your list the next time you create an event, or add new ones during event creation."
        showAdd={canModify}
        addTitle="Add Vendor"
        addAction={() => {
          if (!canModify) {
            return;
          }
          setActiveTab(HOME_TABS.vendors);
          history.push('/vendor/new');
        }}
      />
      {loading ? (
        <Loading />
      ) : (
        <VendorTable vendors={vendors} canModify={canModify} />
      )}
    </>
  );
}
